import axios from "../../lib/axiosInstance";

export function fetchCompanyUsers(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.id) queryParams.append("id", params.id);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  if (params.fullName?.trim()) queryParams.append("fullName", params.fullName.trim());
  if (params.email?.trim()) queryParams.append("email", params.email.trim());
  if (params.country) queryParams.append("country", params.country);
  if (params.role) queryParams.append("role", params.role);
  if (params.status) queryParams.append("status", params.status);
  if (params?.filter) queryParams.append("filter", params.filter);
  if (params.search?.trim()) queryParams.append("search", params.search.trim());

  const queryString = queryParams.toString();
  return axios
    .get(`companies/users${queryString ? `?${queryString}` : ""}`)
    .then((res) => res.data);
}

export function getCompanyUserById(id) {
  return axios.get(`companies/${id}`).then((res) => res.data);
}

export function submitCompanyProfile() {
  return axios.get("companies/submitProfile").then((res) => res.data);
}

export function updateCompany(id, payload) {
  return axios.patch(`companies/${id}`, payload).then((res) => res.data);
}

export function createCompanyUser(payload) {
  return axios.post(`companies/users`, payload).then((res) => res.data);
}

export function updateCompanyUser(payload) {
  return axios
    .patch(`companies/users/${payload?.id}`, payload)
    .then((res) => res.data);
}

export function deactivateCompanyUser(userId) {
  return axios
    .patch(`companies/users/${userId}/deactivate`)
    .then((res) => res.data);
}

export function activateCompanyUser(userId) {
  return axios
    .patch(`companies/users/${userId}/activate`)
    .then((res) => res.data);
}

export async function fetchCompanies(params = {}) {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  if (params.companyName?.trim())
    queryParams.append("companyName", params.companyName.trim());
  if (params.country) queryParams.append("country", params.country);
  if (params.city) queryParams.append("city", params.city);
  if (params.email) queryParams.append("email", params.email);
  if (params.manager) queryParams.append("manager", params.manager);
  if (params.status) queryParams.append("status", params.status);
  if (params.companyType) queryParams.append("companyType", params.companyType);
  if (params.search?.trim()) queryParams.append("search", params.search.trim());

  const queryString = queryParams.toString();

  return axios
    .get(`/companies${queryString ? `?${queryString}` : ""}`)
    .then((res) => res.data?.data);
}
